import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import Swal from 'sweetalert2';
import { Orders } from 'src/app/models/Orders.model';
import { Products } from 'src/app/models/Product.model';
import { OrdersService } from 'src/app/services/orders.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import { PreparazioneOrdiniDetaggliComponent } from '../../preparazione-ordini-detaggli.component';

/**
 * Sub-modale "Codici QR prodotto" — visualizza i barcode di un prodotto.
 *
 * Cross-use: usato sia in `confirm-products` (J.4 wizard picking) che in
 * `storico-ordini/product-details-storico` (v2.9.0). Touch leggero in J.4.c:
 * @Input/@Output preservati, drop kendo-dialog → Diakonix modal native,
 * drop console.log + dead code.
 *
 * Cleanup v2.11.0 J.4.c:
 * - 🚨 FIX DEAD: forEach con body interamente commentato in ngOnInit.
 * - 🚨 FIX DEAD: `barcodes_text` field mai usato.
 * - Drop ~8 console.log (incluso "MAMA MEA E FLORAREASA" 🇷🇴
 *   "mia madre è fioraia").
 * - Switch a inject() + takeUntilDestroyed.
 */
@Component({
  selector: 'app-products-qrcodes',
  templateUrl: './products-qrcodes.component.html',
  styleUrls: ['./products-qrcodes.component.scss'],
  standalone: false,
})


export class ProductsQRCODESComponent implements OnInit {

  @Input() openedQRS = false;
  @Input() product!: Products.Product;
  @Input() order!: Orders.Order;
  @Output() public valueChange = new EventEmitter<boolean>();

  // === DI ===
  private destroyRef = inject(DestroyRef);
  private orderService = inject(OrdersService);
  private parentComponent = inject(PreparazioneOrdiniDetaggliComponent, { optional: true });
  public closeServ = inject(OpenModalService);

  // === State ===
  public index = -1;
  public barcodesOnSubProducts: any[] = [];

  ngOnInit(): void {
    this.index = this.order.products.indexOf(this.product);

    if (this.order.products[this.index]?.barcodes?.length === 0) {
      this.barcodesOnSubProducts = this.order.products[this.index].sub_products ?? [];
    }
  }

  close(): void {
    this.closeServ.seeQROFF();
  }

  deleteBarcode(barcode: Products.Barcodes): void {
    barcode.barcode_text = null;
    barcode.lot = null;
    barcode.progressive = null;
  }

  updateOrder(): void {
    const foundIndex = this.order.products.findIndex(
      (el) => el.indexNo === this.product.indexNo,
    );
    if (foundIndex === -1) return;

    this.order.products[foundIndex] = this.product;
    this.orderService
      .updateLazyOrder(this.order)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (!data?.success) return;
        Swal.fire({
          icon: 'success',
          title: 'Modifiche!',
          text: 'QR aggiornati con successo.',
          timer: 1500,
          timerProgressBar: true,
        });
        // Notify parent J.3 (se siamo dentro confirm-products → preparazione-ordini-detaggli).
        // In storico-ordini parent è null, skip senza errori.
        this.parentComponent?.triggerFunctionSubject?.next(true);
        this.closeServ.seeQROFF();
      });
  }
  
}
